
                  export default function (Component) {
                      Component.__source = "library/layouts/index.vue"
                  }
              